import type { FaireProductEntity } from "../../entity_types/product";

export const p_hg354pg9y5: FaireProductEntity = {
  token: "p_hg354pg9y5",
  type: "product",
  name: "Mama MINI Bracelet – Inspirational Matching Jewelry, Pearl",
  brandToken: "b_v9th4ehh4b",
  brandName: "Two and Crew - Faith Based Jewelry & Gifts",
  imageUrl:
    "https://cdn.faire.com/fastly/7f6d2567f754cef65a20d90d0b7fa0cfb185b88484f1b2a13387ed5428a7bc8d.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/475605c5a85ff1219a892f33ce1920e78cd714677db70d55542ce02835e4a2d5.jpeg",
    "https://cdn.faire.com/fastly/80dfe5f84911457666481d05dd618417a52c016f4a2bd34468739a05da79b0b4.jpeg",
    "https://cdn.faire.com/fastly/202c34669d3da6845acc84fab893af04fcbe2b0f05434b8d92bffba4fc40f08f.jpeg",
    "https://cdn.faire.com/fastly/f508c3d930e5d93fec7e0cd30b5ccf23affcc8251b21f20f3126489ab00b1147.jpeg",
    "https://cdn.faire.com/fastly/88f5f1d1e7db21227384b803bfb067f7c5c5df8c807ce7ff024dbed93cc594d8.jpeg",
    "https://cdn.faire.com/fastly/53b5b78095d8d8116c8de8c3be16bc75962f047669acc23171e4d0704542542b.jpeg",
    "https://cdn.faire.com/fastly/a098ac52540ca7f2013e9edd5897d8a823a613cebacedf4a2d0559a95ee51741.jpeg",
    "https://cdn.faire.com/fastly/14bc9c923438134c074419b7ff5d82447476aa7d284e3b7d9569e57d04722b75.jpeg",
    "https://cdn.faire.com/fastly/776e328896d3c7d2ed81c0034ff60fc1261db516307a165a3b44a429a40475ac.jpeg",
  ],
  priceDollars: 7.53,
  description:
    "Celebrate the bond between mother and child with this Mama and Mini Bracelet Set, designed with colorful letter beads, gold spacers, and a sweet matching style. Each set is unique, making it a one-of-a-kind keepsake for moms and their little ones.\n\nDetails:\n\n- Set includes 1 adult-sized Mama bracelet + 1 child-sized Mini bracelet\n\n- Multi-colored letter beads with shimmering gold spacers\n\n- Stretch design for a comfortable and easy fit\n\n- Each set has a unique mix of bead colors – no two are alike\n\n- Packaged on a display card with the phrase: “Raising beautiful, strong, powerful humans”\n\nPerfect for gifting on Mother’s Day, baby showers, birthdays, Christmas, or any milestone that celebrates motherhood.",
  tags: [],
  msrpDollars: 20.53,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-04-19T21:22:45.180Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
